import { NgModule } from '@angular/core';
import { ArmoryComponent } from './armory.component';
import { BannerComponent } from './banner/banner.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { LayoutModule } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AppNavComponent } from './app-nav/app-nav.component';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [ArmoryComponent, BannerComponent, AppNavComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    // LayoutModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    RouterModule,
    MatTooltipModule,
  ],
  exports: [ArmoryComponent, AppNavComponent]
})
export class ArmoryModule { }
